import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { filterData } from 'filters/selectors';
import dataService from 'api/dataService';
import { getData, dataReceived } from 'datahub/actions';
import { connect } from 'react-redux';

class Pagination extends Component {
  handlePageClick = option => {
    const { filters, handleFilters } = this.props;

    let selected = option.selected;
    selected++;

    const filteredResult = { ...filters, ...{ page: selected } };
    handleFilters(filteredResult);
  };

  render() {
    const { dataPageCount, dataList, fetching } = this.props;
    const currentPage = Number(dataList.meta.current_page);

    if (fetching) {
      return null;
    }

    return (
      <ReactPaginate
        previousLabel={'◀︎'}
        nextLabel={'▶︎'}
        breakLabel={<a href=""> ...</a>}
        breakClassName={'break-me'}
        pageCount={dataPageCount}
        disableInitialCallback={true}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={this.handlePageClick}
        containerClassName={'pagination'}
        subContainerClassName={'pages pagination'}
        activeClassName={'active'}
        initialPage={currentPage - 1}
      />
    );
  }
}

const mapStateToProps = state => {
  const { total, per_page } = state.datahub.dataList.meta;
  const pageCount = Math.ceil(total / per_page);
  return {
    filters: state.filters,
    dataPageCount: pageCount,
    dataList: state.datahub.dataList,
    fetching: state.datahub.fetching
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleFilters: filters => {
      const queryParams = filterData(filters);
      dispatch(getData());
      dataService.getDataList(queryParams).then(response => {
        dispatch(dataReceived(response));
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Pagination);



// WEBPACK FOOTER //
// ./src/components/layouts/pagination/pagination.js